<template>
  <div class="com-box">
    <div class="notice-bar">
      <van-notice-bar left-icon="volume-o" background="rgba(233,51,51,0.33)" color="#F3F4F5" :scrollable="false">
        <van-swipe
          vertical
          class="notice-swipe"
          :autoplay="3000"
          :show-indicators="false"
        >
          <!-- <van-swipe-item v-for="(item,index) in spikeRolling" :key="index">
            {{`刚刚${item.contactsName}秒杀了${item.goodsName}`}}
          </van-swipe-item> -->
        </van-swipe>
      </van-notice-bar>
    </div>
    <div class="commodity-box" v-if="comData.goods.length">
      <div class="commdity-item" v-for="(item,index) in comData.goods" :key="index" @click="jumpDetail(item)">
        <div class="head-box">
          <van-image class="head-img" :src="item.headImg || item.headImgList[0].url" alt="" fit="cover" />
          <div class="tab">{{item.goodsTag}}</div>
        </div>
        <div class="bottom-box">
          <div class="commdity-name">{{item.goodsName}}</div>
          <div class="tips">火热疯抢中</div>
          <div class="price-box">
            <div class="left-box">
              <span class="seckill-price" v-if="item.groupBuyPrice > 0">¥{{item.groupBuyPrice}}</span>
              <span class="seckill-price" v-else>免费</span>
              <span class="original-price">¥{{item.oldPrice}}</span>
            </div>
            <span class="right">{{item.teamNumber}}人团</span>
          </div>
          <div class="handle-box">
            <div class="left">还剩50件</div>
            <div class="right">
              <span class="text">马上下单</span>
              <van-icon name="arrow" size="16" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <img class="img-box" v-else src="https://img3.quanyou.com.cn/joyNew/group1/M00/1D/0A/rB8LrmUw9CqAVToAAAG_W8L1ywQ297.png" alt="" />
  </div>
</template>

<script>
import mixins from './mixins'
export default {
  mixins: [mixins]
}
</script>

<style lang="stylus" scoped>
  .com-box {
    width: 100%;
    height: 460px;
    background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1D/0C/rB8LrmUxCjSAEo4yAAFAA2AjeQ4845.png');
    background-size: 100% 100%;
    overflow hidden
    .notice-bar {
      width: 339px;
      height: 26px;
      background: #FF8D3F;
      box-shadow: 0px 0px 3px 1px rgba(168,37,0,0.6);
      border-radius: 5px;
      margin: auto;
      margin-top: 110px;
      >>> .van-notice-bar {
        height: 26px;
        color: #FFFFFF;
        font-size: 9px;
        background: transparent;
      }
      .notice-swipe {
        height: 26px;
        line-height: 26px;
      }
    }
    .commodity-box {
      display: flex;
      width: 347px;
      height: 247px;
      border-radius: 5px;
      margin: auto;
      margin-top: 10px;
      overflow-x: auto;
      .commdity-item {
        width: 155px;
        background: #FFF9EE;
        border-radius: 5px;
        box-sizing: border-box;
        margin-right: 10px;
        &:nth-last-child(1) {
          margin-right: 0;
        }
        .head-box {
          position: relative;
          width: 100%;
          .head-img {
            width: 100%;
            height: 100px;
          }
          .tab {
            position: absolute;
            left: 0;
            top: 0;
            width: 76px;
            height: 21px;
            font-size: 8px;
            color: #fff;
            font-weight: bold;
            text-align: center;
            line-height: 18px;
            padding-left: 10px;
            box-sizing: border-box;
            background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1D/26/rB8LrmUyHm6AMnQ4AAAKfIc4yKk274.png');
            background-size: 100% 100%;
          }
        }
        .bottom-box {
          padding: 8px;
          .commdity-name {
            height: 34px;
            color: #000000;
            font-size: 15px;
            font-weight: bold;
            margin-top: 10px;
          }
          .tips {
            color: #D27E3F;
            font-size: 11px;
          }
          .price-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
            .left-box {
              .seckill-price {
                color: #EE591D;
                font-weight: bold;
                font-size: 17px;
              }
              .original-price {
                color: #AAADB5;
                font-size: 10px;
                text-decoration: line-through;
                margin-left: 5px;
              }
            }
            .right {
              width: 33px;
              height: 14px;
              color: #F02526;
              font-size: 9px;
              text-align: center;
              line-height: 14px;
              background: #FFD648;
              border-radius: 2px;
            }
          }
          .handle-box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 139px;
            height: 37px;
            padding: 4px;
            box-sizing: bold;
            box-sizing: border-box;
            background: url('https://img3.quanyou.com.cn/joyNew/group1/M00/1D/0B/rB8LrWUw7KqAWos-AAAkcI7UrvM139.png');
            background-size: 100% 100%;
            margin-top: 6px;
            .left {
              width: 75px;
              height: 26px;
              color: #EE591D;
              font-weight: 500;
              text-align: center;
              line-height: 26px;
              background: #FFE6D8;
              border-radius: 3px;
            }
            .right {
              display: flex;
              align-items: center;
              width: 45px;
              color: #FFFFFF;
              font-size: 13px;
              .text {
                width: 30px;
                font-weight: 400;
              }
            }
          }
        }
      }
    }
    .img-box {
      display: block;
      width: 347px;
      height: 247px;
      margin: auto;
      margin-top: 10px;
    }
  }
</style>